/**
 * 新疆舆情功能列表
 * 2017-12-24
 * by yuzaiyang 2017-12-24
 */
"use strict";
angular.module("functionListModule", [
    //服务-分享弹层
]).
controller("functionListCtrl", ["$scope", "$filter", "trsHttpService", '$q',"planCommandMonitorService", function($scope , filter , trsHttpService , $q ,planCommandMonitorService) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {};
        $scope.data = {};
    }
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {
        requestData();
    }
    /**
     * [requestData description] 请求数据
     */
    function requestData() {
        var params = {
             "typeid": 'screen',
             "serviceid": 'zjsentimentFunMgr',
             "modelid": 'getZjSentimentlist',
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            //$scope.hotFeatureList = JSON.parse(data.mapResult.content);
            var copyList = [];
            for (var i = 0; i < data.mapResult.content.length; i ++) {
                copyList.push(data.mapResult.content[i]);
            }
            $scope.zjFunctionList = copyList;
        });
    }
    /**
     * [shareLink description] 分享链接
     * @return {[type]} [description]
     */
    $scope.shareLink = function(id){
        planCommandMonitorService.share(id,'3', "复制链接和密码");
        // functionListService.shareLink(id,'3', "复制链接和密码");
    };
    /**
     * [scan description:用于查看时打开网页]
     * @param  {[type]} url [description]
     * @return {[type]}     [description]
     */
    $scope.scan = function(item) {
        window.open(item);
    };
}]);